import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import moment from 'moment';
import React from 'react';
import { addLocaleData, IntlProvider } from 'react-intl';
import { Provider } from 'mobx-react';
import LocaleStore from './common_components/localization/LocaleStore';
import Main from './memberships_components/Main';
import membershipsLocales from '../locales/memberships.json';
import RootStore from './memberships_components/stores/RootStore';
import TooltipStore from './common_components/tooltips/TooltipStore';
import { TOOLTIPPROPS } from './memberships_components/constantsTooltips';
import { BrowserRouter } from 'react-router-dom';

addLocaleData([...es, ...en]);

export default class Memberships extends React.Component {
  constructor(props) {
    super(props);

    const boardRoles = [
      'none',
      'board_of_director',
      'advisory_board',
      'advisory_service'
    ];
    props.roles.pop();
    const roles = ['ceo'].concat(props.roles);

    const features = {
      responsibilities: props.responsibilities,
      roles,
      mRoles: roles.filter(e => !boardRoles.includes(e)),
      bRoles: boardRoles,
      skills: props.skills,
      customSkills: props.customSkills
    };

    const localeStore = new LocaleStore(props.locale, [membershipsLocales]);
    const memberships = JSON.parse(props.memberships);
    const params = new URLSearchParams(window.location.search);
    const modal = params.get('modal');
    this.state = { modal };

    this.rootStore = new RootStore(
      props.invitations,
      memberships,
      features,
      props.permissions,
      props.currentUser,
      props.role,
      modal,
      localeStore,
    );

    const tooltipStore = new TooltipStore(this.rootStore, TOOLTIPPROPS);
    this.rootStore.tooltipStore = tooltipStore;

    moment.locale(props.locale);
  }

  render() {
    const { locale } = this.rootStore.localeStore;
    const { messages } = this.rootStore.localeStore;

    return (
      <Provider
        rootStore={this.rootStore}
        affiliationStore={this.rootStore.affiliationStore}
        membersStore={this.rootStore.membersStore}
        isPremium={this.props.isPremium}
      >
        <IntlProvider locale={locale} messages={messages}>
          <BrowserRouter>
            <Main {...this.props} />
          </BrowserRouter >
        </IntlProvider>
      </Provider>
    );
  }
}
